module.exports = __webpack_public_path__ + "static/img/002.a97bfe00.svg";